import { Component, OnInit } from '@angular/core';
import { ThemeCustomizerService } from '../../common/theme-customizer/theme-customizer.service';

interface DepartmentTab {
  id: string;
  label: string;
}

interface FactItem {
  title: string;
  value: string;
}

interface AcademicUnitItem {
  title: string;
  description: string;
}

interface LabItem {
  title: string;
  image: string;
  description: string;
}

interface EventPhotoItem {
  image: string;
  alt: string;
  caption: string;
}

interface ShNptelItem {
  sno: number;
  staffName: string;
  designation: string;
  courseName: string;
  certification: string;
}

interface AssociationActivityItem {
  sno: number;
  eventTitle: string;
  eventDate: string;
  resourcePerson?: string;
  description: string;
}

interface ResearchPublicationItem {
  sno: number;
  journalName: string;
  paperTitle: string;
  authorName: string;
  indexedIn: string;
  publicationDate: string;
}
interface AchievementItem {
  title: string;
  description: string;
}
@Component({
  selector: 'app-about-page-one',
  templateUrl: './about-page-one.component.html',
  styleUrls: ['./about-page-one.component.scss']
})
export class AboutPageOneComponent implements OnInit {
  isToggled = false;
  selectedTab = 'tab1';

  departmentName = 'Department of Science & Humanities';
  academicRole = 'Foundation for First Year Engineering';
  coreAreas = 'Mathematics, Physics, Chemistry, English';
  focusArea = 'Communication, Science, Analytical Skills';
  contactEmail = 'hodsh@fmcet.ac.in';

  admissionNotice =
    'Admissions open for 2026 : B.E. (Civil), B.E. (CSE), B.E. (CSE - AI & ML), B.E. (CSE - CS),B.Tech. (AI & DS), B.E. (ECE), B.E. (EEE), B.E. (Mechanical), MBA,M.E. (CSE), M.E. (Embedded System Technologies),M.E. (Thermal Engineering), M.E. (Environmental Engineering)';

  tabs: DepartmentTab[] = [
    { id: 'tab1', label: 'About the Department' },
    { id: 'tab2', label: 'Vision & Mission' },
    { id: 'tab3', label: 'Industrial Visit' },
    { id: 'tab4', label: "Fresher's Day" },
    { id: 'tab12', label: 'Association & Club Activities' },
    { id: 'tab5', label: 'Laboratory Facilities' },
    { id: 'tab6', label: 'Induction Program' },
    { id: 'tab7', label: 'Personality Development Camp' },
    { id: 'tab11', label: 'Achievements' },
    { id: 'tab8', label: 'NPTEL' },
    { id: 'tab9', label: 'Foreign Language Training' },
    { id: 'tab10', label: 'Research' }
  ];

  aboutParagraphs: string[] = [
    'The Department of Science and Humanities is set up to cater to the needs of budding engineers. One of the most important aspects of engineering is effective communication, both verbal and written.',
    'The department helps students strengthen their communication ability, scientific understanding, analytical thinking, and interdisciplinary readiness. It targets academic prominence in the latest trends and establishes awareness and exposure in multidisciplinary engineering domains.',
    'The department inducts students into the engineering ecosystem and supports them in succeeding with both technical skills and aptitudes.'
  ];

  quickFacts: FactItem[] = [
    {
      title: 'Department Role',
      value: 'Academic foundation for all first-year engineering students'
    },
    {
      title: 'Core Strength',
      value: 'Scientific fundamentals, communication, analytical thinking, and multidisciplinary readiness'
    },
    {
      title: 'Learning Outcome',
      value: 'Supports verbal, written, theoretical, practical, and problem-solving development'
    },
    {
      title: 'Academic Scope',
      value: 'Bridges science, humanities, and engineering for stronger technical education'
    }
  ];

  academicUnits: AcademicUnitItem[] = [
    {
      title: 'Department of Mathematics',
      description:
        'Mathematics gives structure to engineering design, theory, and problem solving. The department supports students with strong fundamentals and faculty expertise in areas like topology, generalized matrix theory, fluid dynamics, and graph theory. Faculty members have also published research papers in peer-reviewed journals.'
    },
    {
      title: 'Department of Physics',
      description:
        'Physics is a core building block for all branches of engineering. It gives mathematical equations practical meaning and supports deeper understanding in Nanotechnology, Quantum Physics, Semiconductor Physics, Optics, Material Science, Electromagnetics, Thermal Physics, Crystallography, Fiber Optics, and Electronics.'
    },
    {
      title: 'Department of Chemistry',
      description:
        'The Department of Chemistry provides excellent infrastructure and sophisticated equipment to support strong foundational learning and training. Engineering Chemistry helps students understand both Engineering Chemistry and Environmental Engineering in a practical and career-oriented manner.'
    },
    {
      title: 'Department of English',
      description:
        'English plays a major role in technological and scientific progress. The department contributes significantly by strengthening communication skills through Listening, Speaking, Reading, and Writing, along with functional grammar, helping students grow in academic and professional environments.'
    }
  ];

  visionText =
    'To be one of the leading and preferred engineering colleges in education, research and ethics, and achieve greater recognition for our efforts to make the world look to us for technology and methodology for future trends and innovations.';

  missionPoints: string[] = [
    'To develop high-quality technical education and technocrats with a sound grip on basic engineering principles, technical, and managerial skills.',
    'To innovate research capabilities, and exemplary professional conduct to lead and to use technology for the progress of humanity.',
    'To adapt themselves to changing technological conditions with the highest ethical values.'
  ];

  labs: LabItem[] = [
    {
      title: 'Physics Laboratory',
      image: 'assets/img/gallery/sh/2.jpg',
      description:
        'FMCET has a well-equipped state-of-the-art Physics Laboratory with instruments for experiments in Optics, Electricity and Magnetism, Modern Physics, and General Physics. It helps students gain exposure to experimental physics, engineering acumen, teamwork, and lifelong learning skills while building strong scientific fundamentals.'
    },
    {
      title: 'Chemistry Laboratory',
      image: 'assets/img/gallery/sh/3.jpg',
      description:
        'The Chemistry Laboratory provides conceptual understanding of the basic principles involved in chemical analysis. Most experiments are aligned with theory and help students develop foundational concepts and practical skills that support both engineering applications and future career readiness.'
    },
    {
      title: 'Language Laboratory',
      image: 'assets/img/gallery/sh/4.jpg',
      description:
        'The department has a state-of-the-art Language and Multimedia Interactive Laboratory that helps students improve the four major language skills — Listening, Speaking, Reading, and Writing. It also prepares students for real-life communication through role plays, pair work, and individual tasks.'
    }
  ];

  industrialVisitTitle = 'Industrial Visit';

  industrialVisitParagraphs: string[] = [
    'On 02nd March 2026, as part of the external practical learning, our first-year students visited the Government Industrial Training Institute located in Sivagangai.',
    'During the visit, students explored 3D printing technology and learned its principles, applications, and modern manufacturing insights.',
    'The visit gave students practical exposure beyond the classroom and helped them understand emerging technologies in manufacturing and design.'
  ];

  industrialVisitPhotos: EventPhotoItem[] = [
    {
      image: 'assets/img/sh/iv1.jpeg',
      alt: 'Industrial Visit to Government Industrial Training Institute Sivagangai - Photo 1',
      caption: 'First-year students visited the Government Industrial Training Institute, Sivagangai on 02.03.2026.'
    },
    {
      image: 'assets/img/sh/iv2.jpeg',
      alt: 'Industrial Visit to Government Industrial Training Institute Sivagangai - Photo 2',
      caption: 'Students explored 3D printing technology and its practical applications during the industrial visit.'
    }
  ];

  freshersDayTitle = "Fresher's Day Celebration";

  freshersDayParagraphs: string[] = [
    'Our department organized a vibrant Fresher’s Day celebration on 18 August 2025 to warmly welcome first-year students into the institution.',
    'Ilaiya Abdul Kalam Dr. I. Jegan, International Motivational Speaker, delivered the Fresher’s Day address and inspired the students at the beginning of their academic journey.',
    'The event helped the students feel at home and gave them a positive start to their college life.'
  ];

  freshersDayPhotos: EventPhotoItem[] = [
    {
      image: 'assets/img/sh/fd1.jpeg',
      alt: "Fresher's Day Celebration Photo 1",
      caption: 'Fresher’s Day celebration organized by the Department of Science & Humanities on 18.08.2025.'
    },
    {
      image: 'assets/img/sh/fd2.jpeg',
      alt: "Fresher's Day Celebration Photo 2",
      caption: 'Address by Ilaiya Abdul Kalam Dr. I. Jegan during the Fresher’s Day celebration on 18.08.2025.'
    }
  ];

  associationActivities: AssociationActivityItem[] = [
    {
      sno: 1,
      eventTitle: "Guest Lecture on 'Basis and Dimensions'",
      eventDate: '30.01.2026',
      resourcePerson: 'Dr. S. Sahaya Arockiya Selvi, Professor of Maths, SMCET, Kalayarkoil',
      description:
        "Our department hosted a Guest Lecture on 'Basis and Dimensions' on 30th January 2026. The session enhanced students' understanding of linear algebra and problem-solving skills."
    },
    {
      sno: 2,
      eventTitle: 'National Science Day 2K26 (Ideasprint2K26)',
      eventDate: '27.02.2026',
      description:
        'Our department successfully organized National Science Day 2K26 (Ideasprint2K26) on 27th February 2026 at the college campus with the objective of fostering scientific curiosity, creativity, and innovation among students.'
    },
    {
      sno: 3,
      eventTitle: "Guest Lecture on 'Stress Management'",
      eventDate: '30.10.2025',
      resourcePerson: 'Dr. S. Gowri, Ex-Vice Chancellor, University of Madras',
      description:
        "On 30th October 2025, our department organized a Guest Lecture on the topic 'Stress Management'. The session helped students learn effective stress-handling skills for a balanced life."
    }
  ];

  associationActivityPhotos: EventPhotoItem[] = [
    {
      image: 'assets/img/sh/aa1.jpeg',
      alt: 'Association and Club Activity Photo 1',
      caption: "Guest Lecture on 'Basis and Dimensions' conducted on 30.01.2026."
    },
    {
      image: 'assets/img/sh/aa2.jpeg',
      alt: 'Association and Club Activity Photo 2',
      caption: 'Guest Lecture on Stress Management - Dr. S. Gowri, Ex-Vice Chancellor, University of Madras'
    },
    {
      image: 'assets/img/sh/aa3.jpeg',
      alt: 'Association and Club Activity Photo 3',
      caption: 'National Science Day 2K26 (Ideasprint2K26) organized on 27.02.2026.'
    }
  ];

  inductionProgramTitle = 'Induction Programme';

  inductionProgramParagraphs: string[] = [
    'Our department conducted a four day Induction Programme for first year students from 21.08.2025 to 26.08.2025 at Michael Auditorium.',
    'Various sessions including orientation talks, yoga, motivational lectures, and skill building activities were organized as part of the programme.',
    'The programme helped students understand the academic environment and begin their college journey with confidence and clarity.'
  ];

  inductionProgramPhotos: EventPhotoItem[] = [
    {
      image: 'assets/img/sh/ip1.jpeg',
      alt: 'Induction Programme Photo 1',
      caption: 'Induction Programme conducted for first year students at Michael Auditorium from 21.08.2025 to 26.08.2025.'
    },
    {
      image: 'assets/img/sh/ip2.jpeg',
      alt: 'Induction Programme Photo 2',
      caption: 'Orientation, yoga, motivational lectures, and skill building activities organized during the Induction Programme.'
    }
  ];

  personalityDevelopmentCampTitle = 'Personality Development Camp';

  personalityDevelopmentCampParagraphs: string[] = [
    'On 26th August 2025, our department organized a one day Personality Development Camp for first year students.',
    'The team from JCI trainers trained our students in this camp through interactive and motivating sessions.',
    'The programme supported students in improving confidence, communication, mindset, and personal growth at the beginning of their academic journey.'
  ];

  personalityDevelopmentCampPhotos: EventPhotoItem[] = [
    {
      image: 'assets/img/sh/pdc1.jpeg',
      alt: 'Personality Development Camp Photo 1',
      caption: 'One day Personality Development Camp organized for first year students on 26.08.2025.'
    },
    {
      image: 'assets/img/sh/pdc2.jpeg',
      alt: 'Personality Development Camp Photo 2',
      caption: 'JCI trainers conducting personality development sessions for first year students.'
    }
  ];

  shNptelRecords: ShNptelItem[] = [
    {
      sno: 1,
      staffName: 'Mr. A. Athimoolam',
      designation: 'HoD / S&H',
      courseName: 'OBE & Accreditation',
      certification: 'Elite'
    },
    {
      sno: 2,
      staffName: 'Dr. S. Ramalingam',
      designation: 'Prof. Chemistry',
      courseName: 'OBE & Accreditation',
      certification: 'Gold Elite'
    },
    {
      sno: 3,
      staffName: 'Dr. S. Muthupoongodi',
      designation: 'AP / Chemistry',
      courseName: 'OBE & Accreditation',
      certification: 'Silver Elite'
    },
    {
      sno: 4,
      staffName: 'Mr. R. Prabakaran',
      designation: 'AP / Maths',
      courseName: 'OBE & Accreditation',
      certification: 'Silver Elite'
    },
    {
      sno: 5,
      staffName: 'Dr. Vasanthi',
      designation: 'ASP / English',
      courseName: 'OBE & Accreditation',
      certification: 'Silver Elite'
    },
    {
      sno: 6,
      staffName: 'Ms. Bhuvaneswari',
      designation: 'AP / English',
      courseName: 'OBE & Accreditation',
      certification: 'Silver Elite'
    },
    {
      sno: 7,
      staffName: 'Dr. Ajith',
      designation: 'AP / Physics',
      courseName: 'OBE & Accreditation',
      certification: 'Elite'
    }
  ];

  foreignLanguageTrainingTitle = 'Foreign Language Training';

foreignLanguageTrainingParagraphs: string[] = [
  'Our department organized Japanese Language Training for first year students to strengthen their foreign language learning and communication skills.',
  'The programme enabled students to acquire basic knowledge of the Japanese language, including common expressions, pronunciation, and introductory communication practice.',
  'This training helped students enhance their global exposure, cultural understanding, and preparedness for higher studies and career opportunities in international environments.'
];

  foreignLanguageTrainingPhotos: EventPhotoItem[] = [
    {
      image: 'assets/img/sh/fl1.jpeg',
      alt: 'Foreign Language Training Photo 1',
      caption: 'Writing Workshop conducted on 25.09.2025 for first year students.'
    },
    {
      image: 'assets/img/sh/fl2.jpeg',
      alt: 'Foreign Language Training Photo 2',
      caption: 'Students participating in activities to improve academic and creative writing skills.'
    }
  ];

  researchTitle = 'Journal Publication Details';

  researchPublications: ResearchPublicationItem[] = [
    {
      sno: 1,
      journalName: 'Revista Materia',
      paperTitle:
        'Synthesis and Characterization of cerium Oxide nanoparticles by surfactent assisted precipitation method',
      authorName: 'S. Ramalingam',
      indexedIn: 'SCOPUS',
      publicationDate: 'Under Review'
    },
    {
      sno: 2,
      journalName: 'Materials Today Chemistry',
      paperTitle:
        'Mitigating Geotechnical Risks: A Comprehensive Approach to Hazard Management',
      authorName: 'J. Thavaseelan, P. Jeyakumar',
      indexedIn: 'Google Scholar',
      publicationDate: 'Aug 2024'
    },
    {
      sno: 3,
      journalName: 'Int. J. Adv. Sci. Eng. Vol.12 No.2 5593-5601 (2025)',
      paperTitle:
        'Effect of Electron Beam Irradiation on Microstructure, Physico-Chemical Properties and Bioactive Content of Peanut (Arachis hypogaea)',
      authorName: 'S. Muthupoongodi',
      indexedIn: 'SCOPUS',
      publicationDate: 'Dec 2025'
    }
  ];
    achievements: AchievementItem[] = [
    {
      title: 'MEChATRONZ 2K26 - Student Achievement',
      description:
        'The 1st year AIML and EEE students participated in MEChATRONZ 2K26 at Sethu Institute of Technology and brought laurels to the institution by winning 1st prize in TECH TALK CLASH, 2nd prize in TECH TONIC & Quiz Guest, and 3rd prize in Spot the Bot. The students were felicitated with cash prizes, shields, and certificates for their outstanding performance.'
    }
  ];

  achievementPhotos: EventPhotoItem[] = [
    {
      image: 'assets/img/sh/ach1.jpeg',
      alt: 'MEChATRONZ 2K26 Achievement Photo 1',
      caption:
        '1st year AIML and EEE students receiving prizes at MEChATRONZ 2K26, Sethu Institute of Technology.'
    },
    {
      image: 'assets/img/sh/ach2.jpeg',
      alt: 'MEChATRONZ 2K26 Achievement Photo 2',
      caption:
        'Students honored with cash prizes, shields, and certificates for winning multiple events in MEChATRONZ 2K26.'
    }
  ];

  constructor(public themeService: ThemeCustomizerService) {
    this.themeService.isToggled$.subscribe((isToggled) => {
      this.isToggled = isToggled;
    });
  }

  get activeTabLabel(): string {
    return this.tabs.find((tab) => tab.id === this.selectedTab)?.label || 'Department Profile';
  }

  toggleTheme(): void {
    this.themeService.toggleTheme();
  }

  setContent(content: string): void {
    // kept for compatibility with your existing pattern
  }

  selectTab(tab: string): void {
    this.selectedTab = tab;
  }

  openModal(imageSrc: string, caption: string): void {
    // kept for compatibility with your existing component
  }

  closeModal(): void {
    // kept for compatibility with your existing component
  }

  ngOnInit(): void {}
}